import { loginPost, post } from "../../api/HttpClient.js";
import { BASE_URL, ForgotPassword_url, GetLoginById_url, GetLoginByIdPassword_url, ManualLogin_url, Profile_url, RedirectToUrl, Register_url, ResetPassword_url, validateResetPasswordToken_url, validateRegisterConfirmation_url, originMismatch_url, CheckUserVehicle_url, UserLogout_url } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";
import { getGuId } from "../../utils/SecurityService.js";

export const REACT_APP_REQUESTFROM= process.env.REACT_APP_REQUEST_FROM

export function GetLoginById_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel;  
  return loginPost(`${BASE_URL}${GetLoginById_url}`, requestParams);
}

export function GetLoginByIdPassword_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${GetLoginByIdPassword_url}`, requestParams);
}

export function FetchCompaniesByEmail_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${GetLoginByIdPassword_url}`, requestParams);
}

export function RedirectToUrl_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${RedirectToUrl}`, requestParams);
}

export function Profile_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${Profile_url}`, requestParams);
}

export function Register_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${Register_url}`, requestParams);
}
export function ManualLogin_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  requestParams.RequestFrom = REACT_APP_REQUESTFROM; 
  return loginPost(`${BASE_URL}${ManualLogin_url}`, requestParams);
}

export function ForgotPassword_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${ForgotPassword_url}`, requestParams);
}

export function ResetPassword_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${ResetPassword_url}`, requestParams);
}

export function ValidateResetPasswordToken_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return loginPost(`${BASE_URL}${validateResetPasswordToken_url}`, requestParams);
}

export function ValidateRegisterConfirmation_api(uniqueCode) {
  const requestParams = {
    Code: uniqueCode,
    AppVersion: AppConstant.AppVersion,
    Language: AppConstant.Language,
    DeviceID: AppConstant.DeviceID,
    OsVersion: AppConstant.OsVersion,
    ManufactureModel: AppConstant.ManufactureModel,
    ClientId: '8d76d67e5605ccf0f97a2ac5ac8bc3da',
  };

  return loginPost(`${BASE_URL}${validateRegisterConfirmation_url}`, requestParams);
}

export function ValidateOriginMismatch_api(uniqueCode) {
  const requestParams = {
    Code: uniqueCode,
    AppVersion: AppConstant.AppVersion,
    Language: AppConstant.Language,
    DeviceID: AppConstant.DeviceID,
    OsVersion: AppConstant.OsVersion,
    ManufactureModel: AppConstant.ManufactureModel,
    ClientId: '8d76d67e5605ccf0f97a2ac5ac8bc3da',
  };

  return loginPost(`${BASE_URL}${originMismatch_url}`, requestParams);
}

export function CheckUserVehicle_api(requestParams) {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; 
  return post({
    url: `${BASE_URL}${CheckUserVehicle_url}`,
    params: requestParams,
  });
}

export function UserLogout_api(requestParams) {
  /* requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceID = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel; */
  requestParams.FcmToken = `REACT-${getGuId() || ""}`;
  return post({
    url: `${BASE_URL}${UserLogout_url}`,
    params: requestParams,
  });
}
